import Vue from 'vue/dist/vue.min.js';
import store from './store';

const pardotFormInstance = Vue.component('pardot-form', {
    data: function() {
        return {
        }
    },
    computed: {
        paramData: function() {
            return ({
                GAID: store.state.GAID
            })
        }
    },
    methods: {
        handleIframe() {
            let iframe = this.$el;
            let src = this.$el.getAttribute('src');

            window.addEventListener("message", (event) => {
                if (event.origin == "https://info.badgermeter.com") {
                    this.$nextTick(() => {
                        sizeIframe(event);
                        postData(event);
                    });
                }
            });

            const postData = (event) => {
                // console.log(this.paramData);
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage(JSON.stringify(this.paramData), '*');
                } else {
                    iframe.onload = function() {
                        iframe.contentWindow.postMessage(JSON.stringify(this.paramData), '*');
                    }
                }
            }
        
            const sizeIframe = (event) => {
                let data = JSON.parse(event.data);
                // console.log(data);
                if (data.form) {
                    if ( src.includes(data.form) ) {
                        iframe.style.height = `${data.content + 20}px`;
                        if (data.submit) {
                            this.checkScroll();
                        }
                    }
                }
            };
                
        },
        checkScroll() {
            let iframe = this.$el;
            let iframePos = iframe.offsetTop;
            let scrollOffset = window.scrollY;

            if (iframePos < scrollOffset) {
                let elmPos = iframe.getBoundingClientRect().top + window.scrollY - 100;
                setTimeout(function() {
                    window.scrollTo({
                        top: (elmPos - 70),
                        behavior: 'smooth'
                    });
                },500);
            }
        }
    },
    mounted() {
        this.handleIframe();
    }
});

const pardotForm = () => {

    let forms = document.querySelectorAll('.pardot-form');

    let formConstructor = (id) => {
        pardotFormInstance;

        new Vue({
            el: `.pardot-form-${id}`,
        }).$mount(`.pardot-form-${id}`, true);
    }

    if (forms.length > 0) {
        forms.forEach((item, index) => {
            item.classList.add(`pardot-form-${index}`);
            formConstructor(index);
        })
    }

}

export {pardotForm, pardotFormInstance};